module.exports = __webpack_public_path__ + "assets/img/m_doctor.f1c3726d.png";